<div class="tw-flex tw-flex-col tw-gap-4 tw-pb-6" data-testid="edit-tools">
  <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary sm:tw-hidden">{{
    "pluginsChangesApplyRightAway" | i18n
  }}</span>
  <p class="tw-m-0 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary">
    {{ "pluginsEditIntro" | i18n }}
  </p>

  <!--      pinned-->
  <div class="tw-flex tw-items-baseline tw-justify-between tw-px-0.5 tw-pt-1">
    <span
      class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
      >{{ "pluginsPinnedCount" | i18n: pinned().length : maxPins }}</span
    >
    @if (pinned().length > 1) {
      <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary sm:tw-hidden">{{
        "pluginsDragToReorder" | i18n
      }}</span>
    }
    <span class="tw-hidden sm:tw-inline tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
      "pluginsChangesApplyRightAway" | i18n
    }}</span>
  </div>

  <span id="edit-tools-reorder-hint" class="tw-sr-only">{{
    "pluginsReorderKeyboardHint" | i18n
  }}</span>
  <span class="tw-sr-only" role="status" aria-live="polite">{{ reorderAnnouncement }}</span>

  <div
    class="tw-flex tw-flex-col tw-gap-2"
    cdkDropList
    data-testid="edit-tools-pinned"
    (cdkDropListDropped)="onPinnedDrop($event)"
  >
    @if (pinned().length === 0) {
      <div
        class="tw-p-3.5 tw-text-center tw-text-[13px] tw-text-color-text-tertiary tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-color-border-strong"
      >
        {{ "pluginsNothingPinned" | i18n }}
      </div>
    }
    @for (tool of pinned(); track tool.id; let i = $index) {
      <div
        cdkDrag
        cdkDragLockAxis="y"
        cdkDragBoundary="[data-testid='edit-tools-pinned']"
        class="tw-flex tw-items-center tw-gap-3.5 tw-h-[54px] tw-pl-2.5 tw-pr-3 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card tw-text-[15px] tw-font-medium"
        [attr.data-testid]="'edit-pinned-' + tool.id"
      >
        <!-- Dashed slot where the row will land (same height, so rows shift instead of overlap). -->
        <div
          *cdkDragPlaceholder
          class="tw-h-[54px] tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-color-intent-brand"
        ></div>
        <!-- Floating copy while dragging: brand-tinted and raised. -->
        <ng-template cdkDragPreview [matchSize]="true">
          <div
            class="tw-flex tw-items-center tw-gap-3.5 tw-w-full tw-h-[54px] tw-pl-2.5 tw-pr-3 tw-rounded-2xl tw-bg-color-accent-today-bg tw-border-[1.5px] tw-border-solid tw-border-color-intent-brand tw-shadow-elevation-overlay tw-text-[15px] tw-font-medium"
          >
            <span
              class="tw-flex tw-items-center tw-justify-center tw-size-7 tw-shrink-0 tw-rounded-full tw-bg-color-status-error-bg tw-text-color-status-error-text"
              ><icon [name]="'minus'" [size]="3.5" [disableArrowOverride]="true"></icon
            ></span>
            <icon [name]="tool.icon" [size]="5" [currentColor]="'color-text-action'"></icon>
            <span class="tw-flex-1 tw-truncate">{{ tool.label ?? (tool.labelKey | i18n) }}</span>
            <icon
              [name]="'grip'"
              [size]="5"
              [currentColor]="'color-text-tertiary'"
              [disableArrowOverride]="true"
            ></icon>
          </div>
        </ng-template>
        <button
          type="button"
          class="tw-flex tw-items-center tw-justify-center tw-size-7 tw-shrink-0 tw-rounded-full tw-bg-color-status-error-bg tw-text-color-status-error-text"
          [attr.aria-label]="('pluginsUnpin' | i18n) + ' ' + (tool.label ?? (tool.labelKey | i18n))"
          (click)="prefs.unpin(tool.id)"
        >
          <icon [name]="'minus'" [size]="3.5" [disableArrowOverride]="true"></icon>
        </button>
        <icon [name]="tool.icon" [size]="5" [currentColor]="'color-text-action'"></icon>
        <span class="tw-flex-1 tw-truncate">{{ tool.label ?? (tool.labelKey | i18n) }}</span>
        <span
          cdkDragHandle
          role="button"
          tabindex="0"
          class="tw-flex tw-items-center tw-p-2 -tw-m-2 tw-touch-none tw-text-color-text-tertiary tw-cursor-grab"
          [attr.aria-label]="'pluginsDragToReorder' | i18n"
          aria-keyshortcuts="Alt+ArrowUp Alt+ArrowDown"
          aria-describedby="edit-tools-reorder-hint"
          (keydown)="onHandleKeydown($event, i)"
        >
          <icon [name]="'grip'" [size]="5" [disableArrowOverride]="true"></icon>
        </span>
      </div>
    }
  </div>

  @if (pinned().length > 0) {
    <div
      class="tw-flex tw-items-center tw-gap-2 tw-px-0.5 tw-text-[12.5px] tw-text-color-text-secondary"
    >
      <icon [name]="'info-circle'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
      @if (spotsLeft() === 0) {
        {{ "pluginsPinFull" | i18n: maxPins }}
      } @else if (spotsLeft() === 1) {
        {{ "pluginsOneSpotLeft" | i18n }}
      } @else {
        {{ "pluginsSpotsLeft" | i18n: spotsLeft() }}
      }
    </div>
  }

  <!--      everything else-->
  <div class="tw-flex tw-items-baseline tw-justify-between tw-px-0.5 tw-pt-1">
    <span
      class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
      >{{
        (hasManualOrder() ? "pluginsEverythingElse" : "pluginsEverythingElseMostUsed") | i18n
      }}</span
    >
    <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
      "pluginsOpensLast30" | i18n
    }}</span>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-2">
    @for (tool of others(); track tool.id) {
      <div
        class="tw-flex tw-items-center tw-gap-3.5 tw-h-[54px] tw-pl-2.5 tw-pr-3 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card tw-text-[15px] tw-font-medium"
        [attr.data-testid]="'edit-other-' + tool.id"
      >
        <button
          type="button"
          class="tw-flex tw-items-center tw-justify-center tw-size-7 tw-shrink-0 tw-rounded-full"
          [ngClass]="
            prefs.isFull
              ? 'tw-bg-color-surface-sunken tw-text-color-border-strong tw-cursor-default'
              : 'tw-bg-color-accent-today-bg tw-text-color-text-action'
          "
          [attr.aria-label]="('pluginsPin' | i18n) + ' ' + (tool.label ?? (tool.labelKey | i18n))"
          [attr.aria-disabled]="prefs.isFull"
          (click)="prefs.pin(tool.id)"
        >
          <icon [name]="'plus'" [size]="3.5" [disableArrowOverride]="true"></icon>
        </button>
        <icon [name]="tool.icon" [size]="5" [currentColor]="'color-text-action'"></icon>
        <span class="tw-flex-1 tw-truncate">{{ tool.label ?? (tool.labelKey | i18n) }}</span>
        <span class="tw-text-xs tw-font-normal tw-text-color-text-tertiary tw-whitespace-nowrap">{{
          prefs.opensOf(tool.id) === 1
            ? ("pluginsOneOpen" | i18n)
            : ("pluginsOpensCount" | i18n: prefs.opensOf(tool.id))
        }}</span>
      </div>
    }
  </div>
</div>
